<template>
  <v-card
    class="d-flex"
    flat
  >
    <v-divider
      vertical
      class="mr-5"
    />
    <div id="categories">
      <div class="text--disabled text-sm-body-2 mt-1">Category</div>
      <v-switch
        v-for="category in categories"
        :key="category.name"
        :label="category.name"
        v-model="category.active"
        class="p-0 ma-1"
        hide-details
        dense
        flat
        @click="handleCategory(category)"
      />
    </div>
    <div
      id="Purity"
      class="ml-8"
    >
      <div class="text--disabled text-sm-body-2 mt-1">Purity</div>
      <v-switch
        v-for="purity in purities"
        :key="purity.name"
        :label="purity.name"
        :color="purity.color"
        :disabled="!getPermission && purity.permission"
        v-model="purity.active"
        class="p-0 ma-1"
        hide-details
        dense
        flat
        @click="handlePurity(purity)"
      />
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'OptionsWallheaven',

  data() {
    return {
      categories: [
        { name: 'General', active: Boolean },
        { name: 'Anime', active: Boolean },
        { name: 'People', active: Boolean }
      ],
      purities: [
        { name: 'SFW', active: Boolean, color: 'success', permission: false },
        { name: 'Sketchy', active: Boolean, color: 'warning', permission: true },
        { name: 'NSFW', active: Boolean, color: 'error', permission: true }
      ]
    }
  },

  computed: {
    ...mapState('options', ['options']),
    ...mapGetters('admin', ['getPermission'])
  },

  methods: {
    ...mapActions('options', ['setCategory', 'setPurity']),

    handleCategory(category) {
      this.setCategory(category)
      this.$root.$emit('focusSearch')
    },

    handlePurity(purity) {
      this.setPurity(purity)
      this.$root.$emit('focusSearch')
    }
  },

  created() {
    this.categories.map((category) => {
      category.active = this.options[category.name.toLowerCase()]
    })
    this.purities.map((purity) => {
      purity.active = this.options[purity.name.toLowerCase()]
    })
  }
}
</script>
